import { createTheme } from '@material-ui/core/styles';

const primaryDarkBlue = '#2066A7';
const primaryDarkPurple = '#622F8A';
const primaryDarkPink = '#9A223E';
const primaryBlue = '#789EFF';
const primaryPurple = '#9952D0';
const primaryPink = '#FE5D83';
const primaryLightBlue = '#DAF6FF';
const primaryLightPurple = '#E8D2FF';
const primaryLightPink = '#FFD8E1';

const black = '#454A67';
const black2 = '#0A093D';
const black3 = '#171648';
const black4 = '#2F2C4A';
const white = '#FFFFFF';
const white2 = '#0000000a';
const gray1 = '#5F668C';
const gray2 = '#848CB7';
const gray3 = '#AEB4D2';
const gray4 = '#CCD0E3';
const gray5 = '#E6E8EF';
const gray6 = '#EAEEFB';
const gray7 = '#D2D6E9';
const gray8 = '#F3F3F3';
const gray9 = '#6A6A6A';
const gray10 = '#F9F9F9';
const gray11 = '#ECECEC';
const gray12 = '#7E7E7E';
const gray13 = '#F8F8F8';
const gray14 = '#7F808A';
const gray15 = '#656464';
const gray16 = '#9391A4';
const gray17 = '#C7C9D9';
const blue1 = '#DDE1F0';
const blue2 = '#2E63F0';
const blue3 = '#789EFF';
const blue4 = '#E6F0FF';
const blue5 = '#316BFF';
const blue6 = '#5789E3';
const blue7 = '#1F53A1';
const blue8 = '#ACCCFC';
const blue9 = '#ECF4FF';
const blue10 = '#DAE4FF';
const blue11 = '#217BF4';
const blue12 = '#102170';
const blue13 = '#055689';
const dimBlue = '#CEE2FF';
const purple = '#9766E8';
const pink = '#FE5D83';
const green = '#74C26F';
const greenLight = '#E0FFD9';
const green2 = '#217671';
const green3 = '#70BA6B';
const green4 = '#6CBF93';
const green5 = 'rgba(113, 188, 108, 0.2)';
const green6 = 'rgba(116, 194, 111, 0.2);';
const green7 = '#58BB87';
const green8 = '#E7F5EE';
const green9 = '#34A853';
const green10 = '#35A68D';
const green11 = '#35A68D80';
const orange = '#F46436';
const red = '#f44336';
const purple2 = '#678196'
const transparent = '#FFFFFF';

// const primaryGradient =
//     'radial-gradient(140.2% 109.33% at 89.67% 23.67%, rgba(208, 233, 255, 0.264) 9.88%, rgba(255, 226, 249, 0.356) 92.19%),radial-gradient(190.06% 107.67% at 57.67% -7.67%, #C9FCFF 6.74%, rgba(246, 222, 255, 0.76) 100%)';
const primaryGradient =
    'radial-gradient(140.2% 109.33% at 89.67% 23.67%, rgba(208, 233, 255, 0.264) 9.88%, rgba(255, 226, 249, 0.356) 92.19%)';

const secondaryGradient = 'linear-gradient(256.13deg, #FFFFFF 0%, rgba(255, 255, 255, 0.7) 100%)';

const tertiaryGradient =
    'linear-gradient(256.13deg, #FFFFFF 0%, rgba(255, 255, 255, 0.19) 100%, rgba(255, 255, 255, 0.2) 100%)';

const backdrop =
    'linear-gradient(217.5deg, rgba(69, 74, 103, 0.72) 16.05%, rgba(69, 74, 103, 0.9) 84.29%)';

const shadeGrayGradient =
    'linear-gradient(263.61deg, #FFFFFF 15.63%, rgba(255, 255, 255, 0.5) 94.52%)';

export default createTheme({
    palette: {
        background: {
            default: primaryGradient,
        },
        common: {
            black: black,
            black2: black2,
            black3: black3,
            black4: black4,
            white: white,
            white2: white2,
            gray1: gray1,
            gray2: gray2,
            gray3: gray3,
            gray4: gray4,
            gray5: gray5,
            gray6: gray6,
            gray7: gray7,
            gray8: gray8,
            gray9: gray9,
            gray10: gray10,
            gray11: gray11,
            gray12: gray12,
            gray13: gray13,
            gray14: gray14,
            gray15: gray15,
            gray16: gray16,
            gray17: gray17,
            primaryGradient: primaryGradient,
            secondaryGradient: secondaryGradient,
            tertiaryGradient: tertiaryGradient,
            shadeGrayGradient: shadeGrayGradient,
            backdrop: backdrop,
            blue1: blue1,
            blue2: blue2,
            blue3: blue3,
            blue4: blue4,
            blue5: blue5,
            blue6: blue6,
            blue7: blue7,
            blue8: blue8,
            blue9: blue9,
            blue10: blue10,
            blue11: blue11,
            blue12: blue12,
            blue13: blue13,
            dimBlue: dimBlue,
            purple: purple,
            pink: pink,
            green: green,
            greenLight: greenLight,
            green2: green2,
            green3: green3,
            green4: green4,
            green5: green5,
            green6: green6,
            green7: green7,
            green8: green8,
            green9: green9,
            green10: green10,
            green11: green11,
            orange: orange,
            red: red,
            transparent: transparent,
            primaryBlue: primaryBlue,
            primaryLightBlue: primaryLightBlue,
            primaryDarkBlue: primaryDarkBlue,
            primaryDarkPurple: primaryDarkPurple,
            primaryPurple: primaryPurple,
            primaryLightPurple: primaryLightPurple,
            primaryLightPink: primaryLightPink,
            primaryDarkPink: primaryDarkPink,
            purple2: purple2
        },
        primary: {
            main: primaryBlue,
            light: primaryLightBlue,
            dark: primaryDarkBlue,
        },
        secondary: {
            main: primaryPink,
            light: primaryLightPink,
            dark: primaryDarkPink,
        },
    },
    typography: {
        fontFamily: 'Prompt',
    },

    overrides: {
        MuiPickersToolbar: {
            toolbar: {
                // backgroundColor: lightBlue.A200,
            },
        },
        MuiPickersToolbarText: {
            toolbarTxt: {
                color: white,
            },
            toolbarBtnSelected: {
                color: white,
            },
        },
        MuiPickersCalendarHeader: {
            switchHeader: {
                // backgroundColor: lightBlue.A200,
            },
        },
        MuiPickersDay: {
            day: {
                color: primaryBlue,
            },
            daySelected: {
                // backgroundColor: lightBlue['400'],
                color: white,
            },
            dayDisabled: {
                color: gray4,
            },
            current: {
                color: dimBlue,
            },
        },
        MuiPickersModal: {
            dialogAction: {
                // color: lightBlue['400'],
            },
        },
        MuiPickersClock: {
            clock: {
                // backgroundColor: primaryBlue,
            },
        },
        MuiPickersClockNumber: {
            clockNumber: {
                // color: white,
            },
            clockNumberSelected: {
                color: white,
            },
        },
    },
});
